import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import { MealPlanDataBox, MealPlanDataBoxWithCheckbox } from "@/features/meal-plan/components/MealPlanCard"
import { ClickableItem, HealthPlan, MealPlan } from "@/utils/api-objects/HealthPlan"
import { saveEvent } from "@/utils/apis/user-service"
import { useUserStore } from "@/utils/stores/useUserStore"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"


interface MealPlanPreviewProps {
    mealPlan: MealPlan,
    healthPlan: HealthPlan | null,
}

const MealPlanPreview = (props: MealPlanPreviewProps) => {
    const { sendEvent } = useCreateEvent()
    const mealPlan = props.mealPlan
    const { userData } = useUserStore()
    const email = userData.email
    const navigate = useNavigate()

    const categories = [
        // { title: "🥙 Alimenti consigliati", data: mealPlan.data.food_tips ? mealPlan.data.food_tips : [] },
        ...(props.healthPlan?.data.food_suggested ? [] : [
            { title: "🥙 Alimenti consigliati", data: mealPlan.data.food_tips ? mealPlan.data.food_tips : [] },
        ]),
        ...(props.healthPlan?.data.integrators_suggested ? [] : [
            { title: "💊 Integratori consigliati", data: mealPlan.data.integrators_suggested ? mealPlan.data.integrators_suggested : [] }
        ]),
        // { title: "💊 Integratori consigliati", data: mealPlan.data.integrators_suggested ? mealPlan.data.integrators_suggested : [] },
        { title: "🍲 Linee guida alimentari principali", data: mealPlan.data.guidelines ? mealPlan.data.guidelines : [] },
        { title: "🍳 Ricette e accostamenti suggeriti", data: mealPlan.data.recepees ? mealPlan.data.recepees : [] },
        { title: "👨‍⚕️ Commento del nutrizionista", data: mealPlan.data.nutri_comment ? mealPlan.data.nutri_comment : [] },
        { title: "🥙  Alimenti consigliati", data: mealPlan.data.top_hero_foods ? mealPlan.data.top_hero_foods : [] },
        { title: "💊 Integratori consigliati", data: mealPlan.data.top_integratori ? mealPlan.data.top_integratori : [] },
        { title: "👨‍⚕️ Commento del nutrizionista", data: mealPlan.data.nutrition_recommendations ? mealPlan.data.nutrition_recommendations : [] },
        { title: "👨‍⚕️ Commento del nutrizionista", data: mealPlan.data.comment ? [mealPlan.data.comment] : [] },
        { title: "💡 Cose importanti da tenere a mente", data: mealPlan.data.important_key_points ? mealPlan.data.important_key_points : [] },
    ]
        .filter(category => category.data.length > 0)
        .slice(0, 2);

    const onOpenMealPlanClick = async () => {
        navigate("/meal-plan")
        if (!email) return
        saveEvent(
            email,
            "open_meal_plan_button_clicked",
            (success) => console.log(success),
            (error) => console.log(error),
            "health_plan_page"
        )
        await sendEvent({
            event: EventType.CLICK,
            sub_category: "open_meal_plan",
        })
    }

    useEffect(() => {
        void sendEvent({
            event: EventType.WIDGET_VIEW,
            sub_category: "meal_plan_widget",
        })
    }, [])

    return (
        <div className="bg-[#C2D9FF] rounded-xl pt-[15px] pb-[10px] px-[10px] space-y-sm flex flex-col max-w-[800px]">
            <div className="w-full flex items-center justify-between">
                <div className="font-bold text-[14px]">
                    In evidenza dal tuo Meal Plan
                </div>
                <div
                    className="font-bold text-[12px] text-holifya-blue cursor-pointer"
                    onClick={onOpenMealPlanClick}
                >
                    Apri
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[10px]">
                {categories.map((category, index) => (
                    (category.title === "🍲 Linee guida alimentari principali" || category.title === "🍳 Ricette e accostamenti suggeriti" || category.title === "🥙 Alimenti consigliati" || category.title === "🥙 Alimenti consigliati" || category.title === "💊 Integratori consigliati") ?
                        // (category.title === "🍲 Linee guida alimentari principali" || category.title === "🍳 Ricette e accostamenti suggeriti") ?
                        <MealPlanDataBoxWithCheckbox key={index} title={category.title} data={category.data as ClickableItem[]} fullData={mealPlan.data} planId={mealPlan.id} source="health_plan_page" /> :
                        <MealPlanDataBox key={index} title={category.title} data={category.data as string[]} source="health_plan_page" />
                ))}
            </div>
        </div>
    )
}

export default MealPlanPreview
